module.exports = __webpack_public_path__ + "img/icon_check_alarm_grey.64c522d8.svg";